export const civilities = [ "Monsieur", "Madame" ] as const
export type civilityType = typeof civilities[number]

// personne physique
export type IndividualPersonType = {
    civility: civilityType,
    firstName: string,
    lastName: string,
    postalCode: string,
    city: string,
    address: string,
    additionalAddress: string,
    registrationOffice?: string,
    cities?: string[]
}



export type HeritierType = {
    quality: string,
    civility: civilityType,
    firstName: string,
    birthName?: string
    lastName: string,
    postalCode: string,
    city: string,
    address: string,
    additionalAddress: string,
    registrationOffice?: string,
    cities?: string[],
    profession: string,
}